// #region IMPORTS
import clsx from 'clsx';
import { FaArrowLeft } from 'react-icons/fa';
import BgPattern from '../../assets/flowing_line_yellow.svg?react';
import { AZButton } from '../AZButton';
// CSS
import './NotFoundLayout.css';
// #endregion

// #region INTERFACE
export interface NotFoundLayoutProps {
  /** Callback when the back/redirect button is clicked */
  onGoBack?: () => void;
  /** Tooltip/aria-label for the back button. Default: 'Redirect to login' */
  onGoBackDescription?: string;
  /** Optional, true to animate background, false otherwise */
  animate?: boolean;
  /**bgColor: */
  bgColor: string;
}
// #endregion

// #region COMPONENT
/**
 * @returns A full-page 404 Not Found screen with a message and a button to navigate back to the home page.
 */
const NotFoundLayout = (props: NotFoundLayoutProps) => {
  // #region INITIALIZATION
  // Properties
  const {
    onGoBack = () => null,
    onGoBackDescription = 'Go back',
    animate = true,
    bgColor = 'var(--az-palette-midnight)',
  } = props;
  // #endregion

  // #region INTERFACE
  return (
    <div className="NotFound-Container" style={{ backgroundColor: bgColor }}>
      <div className="NotFound-MainContainer">
        <div className="az-unauth-main">
          <div className="az-unauth-description">
            <h1 className="az-unauth-title">404</h1>
            <p className="az-unauth-subtitle">
              Oups, it seems you have taken a wrong turn but don&apos;t worry, you can go
              back.
            </p>
          </div>
          <div className="az-unauth-button-container">
            <AZButton
              variant="icon"
              icon={<FaArrowLeft />}
              onClick={onGoBack}
              description={onGoBackDescription}
            />
          </div>
        </div>
        <BgPattern
          className={clsx('az-NotFound-bg-svg', animate && 'az-NotFound-bg-animated')}
          aria-hidden="true"
          preserveAspectRatio="none"
        />
      </div>
    </div>
  );
  // #endregion
};
// #endregion

export { NotFoundLayout };
